module.exports = __webpack_public_path__ + "img/dfk-lubowice-35-anniversary.35e4638a.jpg";